function wrapTextToLines(text, maxWidth, fontStyle) {
    const words = text.split(/\s+/);
    let lines = [];
    let currentLine = '';
    const tempText = window.d3.select('body')
        .append('text')
        .attr('style', `font: ${fontStyle}`)
        .style('opacity', 0)
        .style('position', 'absolute');
    words.forEach(word => {
        const testLine = currentLine.length > 0 ? `${currentLine} ${word}` : word;
        tempText.text(testLine);
        if (tempText.node().clientWidth > maxWidth) {
            lines.push(currentLine);
            currentLine = word;
        } else {
            currentLine = testLine;
        }
    });
    lines.push(currentLine);
    tempText.remove();
    return lines;
}

export {
    wrapTextToLines
}